/* BeyondADS proof layer - viewer counter (simulated) + review/sale poppers (real data) */
(function () {
  var dataEl = document.getElementById('bd-proof-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

  function rand(a, b) { return a + Math.floor(Math.random() * (b - a + 1)); }
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------------- viewer counter ---------------- */
  var V = D.viewers || {};
  var KEY = 'bdpLive:' + D.handle;
  var count = parseInt(store(KEY), 10);
  if (!(count >= V.min && count <= V.max)) count = V.seed;

  var EYE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>';

  // viewer badge sits at the right end of the product title row (client, 13 Oct): eye in a stroked circle + figure
  function titleEl() {
    var main = document.querySelector('.product__info-container') || document;
    return main.querySelector('.product__title');
  }

  function mount() {
    if (document.querySelector('.bdp-live')) return;
    var t = titleEl();
    if (!t) return;
    t.classList.add('bdp-titlerow');
    var pill = document.createElement('span');
    pill.className = 'bdp-live';
    pill.tabIndex = 0;
    pill.setAttribute('role', 'status');
    pill.setAttribute('aria-label', count + ' people are viewing this right now');
    pill.innerHTML = '<span class="bdp-live__eye" aria-hidden="true">' + EYE + '</span>' +
      '<span class="bdp-live__num"><b data-bdp-n>' + count + '</b><span class="bdp-live__dot" aria-hidden="true"></span></span>' +
      '<span class="bdp-live__tip" role="tooltip"><span data-bdp-n2>' + count + '</span> people are viewing this right now</span>';
    pill.addEventListener('click', function () { pill.classList.toggle('is-open'); }); // phones: tap shows the wording
    t.appendChild(pill);
  }

  function paintCount() {
    var n = document.querySelector('[data-bdp-n]');
    var n2 = document.querySelector('[data-bdp-n2]');
    if (!n) return;
    if (n.textContent === String(count)) return;
    n.classList.add('is-tick');
    setTimeout(function () {
      n.textContent = count;
      if (n2) n2.textContent = count;
      var pl = document.querySelector('.bdp-live'); if (pl) pl.setAttribute('aria-label', count + ' people are viewing this right now');
      n.classList.remove('is-tick');
    }, 250);
  }

  // small, believable drift inside 1-6: one person at a time, and sometimes nobody comes or goes
  function step() {
    var r = Math.random(), next = count;
    if (r < 0.3) next = count;                    // stays the same
    else next = count + (r < 0.65 ? 1 : -1);      // one more / one fewer
    if (next > V.max) next = V.max - 1;
    if (next < V.min) next = V.min + 1;
    count = Math.max(V.min, Math.min(V.max, next));
    store(KEY, String(count));
    paintCount();
    setTimeout(step, rand(7000, 15000));
  }

  mount();
  setTimeout(step, rand(4000, 9000));

  // Re-mount if the theme re-renders the info column (variant change)
  var info = document.querySelector('.product__info-container');
  if (info && window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; if (!document.querySelector('.bdp-live')) mount(); });
    }).observe(info, { childList: true, subtree: true });
  }

  /* ---------------- poppers: real reviews + real sales ----------------
     Client timing (13 Oct):
       review = first at 4 s, then 5 s after it closes;
       sale   = first at 7 s, then 14 s after it closes;
       every card stays 3 s.
     Each kind has its OWN card and timeline, so neither ever waits for the other.
     When both are on screen they stack: the newer card sits above the older one,
     and when the lower card leaves the upper one glides down into its place.
     Clock = ms since the visitor opened the page (navigation start). */
  var tpl = document.querySelector('[data-bdp-pop]');
  if (!tpl) return;

  var T = { show: 3000, open: 5000, fade: 350, gapDesk: 10, gapPhone: 8 };
  var t0 = Date.now();
  function now() { return (window.performance && performance.now) ? performance.now() : Date.now() - t0; }
  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function stars(n) { var s = ''; for (var i = 0; i < 5; i++) s += i < n ? '★' : '☆'; return s; }
  function shortName(n) {
    var p = String(n || '').trim().split(/\s+/).filter(Boolean);
    if (!p.length) return 'Carbonly customer';
    var first = p[0].charAt(0).toUpperCase() + p[0].slice(1);
    return p.length > 1 ? first + ' ' + p[p.length - 1].charAt(0).toUpperCase() + '.' : first;
  }

  function makeCard(kind, el) {
    document.body.appendChild(el); // escape any transformed parent
    el.className = 'bdp-pop bdp-pop--' + kind;
    var $ = function (s) { return el.querySelector(s); };
    return {
      kind: kind, el: el, items: [], i: 0, state: 'off', shownAt: 0, hideAt: 0, hideT: null, nextT: null,
      link: $('[data-bdp-link]'), img: $('[data-bdp-img]'), kicker: $('[data-bdp-kicker]'),
      main: $('[data-bdp-title]'), meta: $('[data-bdp-meta]'), line: $('[data-bdp-line]'), x: $('[data-bdp-x]')
    };
  }
  var cards = {
    review: makeCard('review', tpl.cloneNode(true)),
    sale: makeCard('sale', tpl)
  };
  cards.review.first = 4000; cards.review.gap = 5000;
  cards.sale.first = 7000; cards.sale.gap = 14000;
  cards.sale.items = shuffle((D.sales || []).slice());

  /* --- fill --- */
  cards.sale.fill = function (s) {
    var c = this;
    c.link.href = s.url;
    c.img.src = s.img; c.img.alt = s.title;
    c.kicker.textContent = 'Someone in ' + s.city + ' purchased';
    c.main.textContent = s.title;
    c.meta.className = 'bdp-pop__meta is-verified';
    c.meta.innerHTML = '<span>Verified order</span>';
    c.line.innerHTML = '<span class="bdp-q"><b>' + esc(s.city) + '</b> · bought ' + esc(s.title) + '</span>';
  };
  cards.sale.photo = function (s) { return s.img; };
  cards.review.fill = function (r) {
    var c = this;
    c.link.href = r.p.url;
    c.img.src = r.p.img; c.img.alt = r.p.title;
    c.kicker.innerHTML = '<span class="bdp-stars" aria-label="' + r.stars + ' out of 5 stars">' + stars(r.stars) + '</span><span>Customer review</span>';
    c.main.textContent = '“' + r.text + '”';
    c.meta.className = 'bdp-pop__meta' + (r.verified ? ' is-verified' : '');
    c.meta.innerHTML = '<span>' + esc(r.name) + (r.verified ? ' · Verified buyer' : '') + ' · ' + esc(r.p.title) + '</span>';
    c.line.innerHTML = '<span class="bdp-q">“' + esc(r.text) + '”</span><span class="bdp-stars">' + stars(r.stars) + '</span>';
  };
  cards.review.photo = function (r) { return r.p.img; };

  /* --- live Vitals reviews (public storefront JSON, CORS *) --- */
  function vitalsUrl(pid) {
    var ck = (window.vtlsLiquidData && window.vtlsLiquidData.cacheKeys && window.vtlsLiquidData.cacheKeys[0]) || 0;
    return 'https://appsolve.io/bundle/api/v2/sf/pr/prd/' + ck + '/p1/' + pid + '.json';
  }
  var reviewsDone = false;
  (function loadReviews() {
    var srcs = (D.reviews || []).slice();
    var got = [];
    function next() {
      var src = srcs.shift();
      if (!src || got.length >= 12) {
        cards.review.items = shuffle(got).slice(0, 40);
        reviewsDone = true;
        if (got.length) (new Image()).src = cards.review.items[0].p.img;
        return;
      }
      fetch(vitalsUrl(src.id)).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        ((d && d.reviews) || []).forEach(function (rv) {
          var text = String(rv.review || '').replace(/\s+/g, ' ').trim();
          if (rv.stars >= 4 && text.length >= 20 && text.length <= 400) {
            got.push({ text: text, stars: rv.stars, name: shortName(rv.name), verified: !!rv.verified, p: src });
          }
        });
      }).catch(function () {}).then(next);
    }
    next();
  })();

  /* --- position: dock above the phone's sticky buy bar, then stack visible cards --- */
  function dockPx() {
    var bar = document.getElementById('buy-me');
    if (!bar) return 0;
    var cs = getComputedStyle(bar), r = bar.getBoundingClientRect();
    // sticky buy bar docked in the lower half: sit above its top edge (covers anything stacked under it)
    if (cs.position === 'fixed' && cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.top > window.innerHeight / 2 && r.top < window.innerHeight) return Math.round(window.innerHeight - r.top);
    return 0;
  }
  // phone: the review card sits at the TOP, just under the header (client, 13 Oct)
  function headerPx() {
    var h = document.querySelector('sticky-header, .header-wrapper, .section-header, header');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 && r.top < 200 ? Math.round(Math.min(r.bottom, 200)) : 0;
  }
  function layout() {
    var phone = window.innerWidth < 750;
    var dock = dockPx() + 'px';
    var top = (headerPx() + 10) + 'px';
    var gap = phone ? T.gapPhone : T.gapDesk;
    [cards.review, cards.sale].forEach(function (c) {
      c.el.style.setProperty('--bdp-dock', dock);
      c.el.style.setProperty('--bdp-top', top);
    });
    if (phone) {
      // different edges (review top, sale bottom): nothing to stack
      cards.review.el.style.setProperty('--bdp-stack', '0px');
      cards.sale.el.style.setProperty('--bdp-stack', '0px');
      return;
    }
    var vis = [cards.review, cards.sale].filter(function (c) { return c.state === 'in' || c.state === 'out'; }) // a fading card keeps its place
      .sort(function (a, b) { return a.shownAt - b.shownAt; }); // oldest at the bottom
    var off = 0;
    vis.forEach(function (c) {
      c.el.style.setProperty('--bdp-stack', off + 'px');
      off += c.el.offsetHeight + gap;
    });
  }

  /* --- per-card timeline --- */
  function schedule(c, at) {
    clearTimeout(c.nextT);
    c.nextT = setTimeout(function () { show(c); }, Math.max(0, at - now()));
  }

  function other(c) { return c === cards.review ? cards.sale : cards.review; }

  function show(c) {
    if (document.hidden) { schedule(c, now() + 1000); return; }
    // the other card is mid fade-out in the slot we would take: let it finish first (max 350 ms)
    var o = other(c);
    if (window.innerWidth >= 750) { // on phones the two cards use different edges, so no hand-off needed
      if (o.state === 'out') { schedule(c, now() + T.fade + 20); return; }
      // the other card leaves within 0.4 s anyway: hand the slot over instead of stacking for a blink
      if (o.state === 'in' && o.hideAt - now() < 400) { schedule(c, o.hideAt + T.fade + 20); return; }
    }
    if (!c.items.length) {
      if (c.kind === 'review' && !reviewsDone) schedule(c, now() + 200); // reviews still loading
      return;
    }
    var item = c.items[c.i++ % c.items.length];
    c.el.classList.remove('is-open');
    c.fill(item);
    c.state = 'loading';
    var done = false;
    function reveal() {
      if (done) return;
      done = true;
      c.state = 'in';
      c.shownAt = now();
      c.el.classList.add('is-placing');      // place without animating the stack offset
      c.el.hidden = false;
      layout();
      void c.el.offsetWidth;
      c.el.classList.remove('is-placing');
      c.el.classList.add('is-in');
      c.hideAt = now() + T.show;
      c.hideT = setTimeout(function () { hide(c); }, T.show);
      var nx = c.items[c.i % c.items.length];
      if (nx) (new Image()).src = c.photo(nx); // warm the next photo
    }
    if (c.img.complete && c.img.naturalWidth) reveal();
    else { c.img.onload = c.img.onerror = reveal; setTimeout(reveal, 1500); }
  }

  // closing a card early means "not this one": its timeline carries on, nothing is persisted
  function hide(c) {
    if (c.state !== 'in') return;
    clearTimeout(c.hideT);
    c.state = 'out';
    c.el.classList.remove('is-in');
    var t = now();
    setTimeout(function () {
      if (c.state === 'out') { c.el.hidden = true; c.state = 'off'; }
      layout(); // once it has faded, the card above (if any) glides down into its place
    }, T.fade);
    schedule(c, t + c.gap);
  }

  [cards.review, cards.sale].forEach(function (c) {
    c.x.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); hide(c); });
    // phone: first tap on a cut-off pill opens it to the full text (and keeps it up 5 s more); next tap follows the link
    c.link.addEventListener('click', function (e) {
      if (window.innerWidth >= 750 || c.state !== 'in' || c.el.classList.contains('is-open')) return;
      var q = c.line.querySelector('.bdp-q');
      if (!q || q.scrollWidth <= q.clientWidth + 1) return; // nothing hidden: go straight to the product
      e.preventDefault();
      c.el.classList.add('is-open');
      clearTimeout(c.hideT);
      c.hideAt = now() + T.open;
      c.hideT = setTimeout(function () { hide(c); }, T.open);
      layout();
    });
  });
  var layQ = false, layT = null;
  function anyIn() { return cards.review.state === 'in' || cards.sale.state === 'in'; }
  function relayout() {
    // trailing pass: the theme's header slides back in with an animation AFTER the scroll event
    clearTimeout(layT); layT = setTimeout(function () { if (anyIn()) layout(); }, 400);
    if (layQ) return; layQ = true; requestAnimationFrame(function () { layQ = false; if (anyIn()) layout(); });
  }
  window.addEventListener('resize', relayout, { passive: true });
  window.addEventListener('scroll', relayout, { passive: true });

  if (cards.sale.items.length) (new Image()).src = cards.sale.items[0].img;
  schedule(cards.review, cards.review.first);
  schedule(cards.sale, cards.sale.first);
})();
